import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export const LoadingFallback = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
    <CircularProgress />
  </Box>
);
